$(function () {
    const disabledDateArray = typeof disabledDates !== 'undefined' ? disabledDates : [];
    const max = typeof maxDate !== 'undefined' ? maxDate : null;
    const min = typeof minDate !== 'undefined' ? minDate : null;
    const disabledWeekendArray = typeof daysOfWeekend !== 'undefined' ? daysOfWeekend : [0, 6]; // Default to Sunday (0) and Saturday (6)

    const defaultConfig = {
        dateFormat: typeof datePickerFormat !== 'undefined' ? datePickerFormat : 'yy/mm/dd', // Default value if datePickerFormat is not defined
        autoclose: true,
        todayHighlight: true,
        monthNames: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
        dayNamesMin: [ "日", "月", "火", "水", "木", "金", "土" ],
        showMonthAfterYear: true,
        minDate: min,
        maxDate: max,
        beforeShow: updateDatePickerTitle,
        onChangeMonthYear: updateDatePickerTitle,
        beforeShowDay: function(date) {
            const day = date.getDay();
            if (disabledWeekendArray.includes(day)) {
                return [false, ''];
            }

            const y = date.getFullYear();
            const m = ('0' + (date.getMonth() + 1)).slice(-2);
            const d = ('0' + date.getDate()).slice(-2);
            const formattedDate = `${y}/${m}/${d}`;

            if (disabledDateArray.includes(formattedDate)) {
                return [false, ''];
            }

            return [true, ''];
        }
    };

    function updateDatePickerTitle(input, inst) {
        setTimeout(() => {
            let dpDiv;

            if (inst.dpDiv) {
                // onChangeMonthYear
                dpDiv = $(inst.dpDiv);
            } else {
                // beforeShow
                dpDiv = $(input).datepicker("widget");
            }

            const title = dpDiv.find('.ui-datepicker-title');
            if (title.length && title.html().includes('&nbsp;')) {
                title.html(title.html().replace('&nbsp;', ' / '));
            }
        }, 10);
    }

    $('.datetimepicker-component').datepicker(defaultConfig);
});
